import script from "./ModeloPropostaRepository.vue?vue&type=script&lang=js"
export * from "./ModeloPropostaRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__